<!-- Header/Navigation -->
<app-navigation></app-navigation>

<!-- Hero Section -->
<section class="hero-partners">
  <div class="container">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          Gana Dinero Vendiendo <span class="partners-highlight">ChatbotPezeta</span>
        </h1>
        <p class="hero-subtitle">
          Únete a nuestro programa de comisionistas y empieza a ganar desde tu primera venta.
          <strong>25% del primer mes + 10% recurrente cada mes</strong> mientras tu cliente permanezca activo.
        </p>

        <!-- Highlight metrics -->
        <div class="hero-metrics">
          <div class="metric-card">
            <div class="metric-number">25%</div>
            <div class="metric-label">Primer mes</div>
          </div>
          <div class="metric-card accent">
            <div class="metric-number">10%</div>
            <div class="metric-label">Cada mes</div>
          </div>
        </div>

        <div class="hero-actions">
          <button (click)="scrollToForm()" class="btn-primary-partners">
            <img src="icons/handshake-solid-full.svg" alt="" class="btn-icon" width="18" height="18">
            Quiero Ser Comisionista
          </button>
          <button (click)="openWhatsApp()" class="btn-secondary-partners">
            <img src="icons/whatsapp.svg" alt="" class="btn-icon" width="18" height="18">
            Hablar por WhatsApp
          </button>
        </div>
      </div>

      <div class="hero-visual">
        <div class="earning-card">
          <div class="card-header">
            <img src="icons/chart-pie-solid-full.svg" alt="" class="card-icon" width="24" height="24">
            <span>Tu Ingreso Mensual</span>
          </div>
          <div class="card-subtitle">Con ritmo constante de 10 ventas/mes (Plan Professional)</div>
          <div class="calculation">
            <div class="calc-row">
              <span class="calc-label">Mes 1 (10 nuevos):</span>
              <span class="calc-value">$7,500</span>
            </div>
            <div class="calc-row">
              <span class="calc-label">Mes 2 (+10 nuevos):</span>
              <span class="calc-value">$10,500</span>
            </div>
            <div class="calc-row">
              <span class="calc-label">Mes 3 (+10 nuevos):</span>
              <span class="calc-value">$13,500</span>
            </div>
            <div class="calc-row highlight">
              <span class="calc-label">Mes 6 (50 activos):</span>
              <span class="calc-value">$22,500</span>
            </div>
            <div class="calc-divider"></div>
            <div class="calc-row total">
              <span class="calc-label">Mes 12 (100+ activos):</span>
              <span class="calc-value">$37,500/mes</span>
            </div>
          </div>
          <p class="card-note">Tus comisiones crecen cada mes porque se acumulan los clientes activos</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Beneficios -->
<section class="benefits-section">
  <div class="container">
    <div class="section-header">
      <h2>¿Por qué unirte a nuestro <strong>programa de comisionistas</strong>?</h2>
      <p>Ventajas reales que hacen la diferencia</p>
    </div>

    <div class="benefits-grid">
      <div class="benefit-card">
        <div class="benefit-icon-wrapper">
          <img src="icons/fire-solid-full.svg" alt="" class="benefit-icon" width="32" height="32">
        </div>
        <h3>Sin Inversión Inicial</h3>
        <p>No necesitas comprar inventario ni pagar membresías. Empiezas a vender sin ningún costo de entrada.</p>
      </div>

      <div class="benefit-card primary">
        <div class="benefit-icon-wrapper">
          <img src="icons/chart-simple-solid-full.svg" alt="" class="benefit-icon" width="32" height="32">
        </div>
        <h3>Comisiones Recurrentes</h3>
        <p>No es un pago único. Ganas el 10% cada mes mientras tu cliente use el servicio. Ingresos pasivos reales.</p>
        <div class="benefit-badge">Ingreso recurrente</div>
      </div>

      <div class="benefit-card">
        <div class="benefit-icon-wrapper">
          <img src="icons/star-solid-full.svg" alt="" class="benefit-icon" width="32" height="32">
        </div>
        <h3>Producto Probado</h3>
        <p>Más de 50 empresas mexicanas ya confían en ChatbotPezeta. Vendes un producto con casos de éxito comprobados.</p>
      </div>

      <div class="benefit-card">
        <div class="benefit-icon-wrapper">
          <img src="icons/people-group-solid-full.svg" alt="" class="benefit-icon" width="32" height="32">
        </div>
        <h3>Soporte para Ventas</h3>
        <p>Te capacitamos, te damos materiales de venta y te apoyamos en demos con clientes. No estás solo.</p>
      </div>

      <div class="benefit-card">
        <div class="benefit-icon-wrapper">
          <img src="icons/shield-halved-solid-full.svg" alt="" class="benefit-icon" width="32" height="32">
        </div>
        <h3>Sin Cuotas ni Metas</h3>
        <p>Vendes a tu ritmo. No hay cuotas mínimas mensuales ni presión por cumplir objetivos. Libertad total.</p>
      </div>

      <div class="benefit-card primary">
        <div class="benefit-icon-wrapper">
          <img src="icons/clock-solid-full.svg" alt="" class="benefit-icon" width="32" height="32">
        </div>
        <h3>Pagos Puntuales</h3>
        <p>Transferencia bancaria cada 15 del mes. Sin demoras, sin pretextos. Tu dinero siempre a tiempo.</p>
        <div class="benefit-badge">Día 15 de cada mes</div>
      </div>
    </div>
  </div>
</section>

<!-- Esquema de Comisiones -->
<section class="commission-section">
  <div class="container">
    <div class="section-header">
      <h2><strong>Esquema de Comisiones</strong></h2>
      <p>Transparencia total sobre tus ganancias</p>
    </div>

    <!-- Visual del esquema -->
    <div class="commission-visual">
      <div class="commission-step">
        <div class="step-number">1</div>
        <div class="step-content">
          <h3>Primer Mes</h3>
          <div class="commission-amount">25%</div>
          <p>Del precio de suscripción cuando el cliente paga su primera mensualidad</p>
        </div>
      </div>

      <div class="arrow-separator">
        <img src="icons/caret-right-solid-full.svg" alt="" class="arrow-icon" width="24" height="24">
      </div>

      <div class="commission-step accent">
        <div class="step-number">2</div>
        <div class="step-content">
          <h3>Todos los Meses</h3>
          <div class="commission-amount">10%</div>
          <p>Cada mes que el cliente permanezca activo y pague su mensualidad</p>
        </div>
      </div>
    </div>

    <!-- Tabla de ganancias -->
    <div class="commission-table-wrapper">
      <h3 class="table-title">Ganancias por Plan</h3>
      <table class="commission-table">
        <thead>
          <tr>
            <th>Plan</th>
            <th>Precio Mensual</th>
            <th>Comisión 1er Mes (25%)</th>
            <th>Comisión Mensual (10%)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let plan of plans">
            <td class="plan-name">{{ plan.name }}</td>
            <td class="price">${{ plan.price | number:'1.0-0' }} MXN</td>
            <td class="commission-primary">${{ plan.commission25 | number:'1.0-0' }}</td>
            <td class="commission-recurring">${{ plan.commission10 | number:'1.0-0' }}/mes</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Ejemplo detallado -->
    <div class="commission-example">
      <div class="example-header">
        <img src="icons/lightbulb-solid-full.svg" alt="" class="example-icon" width="24" height="24">
        <h3>Ejemplo Real</h3>
      </div>
      <p class="example-scenario">Si vendes 10 planes Professional ($2,999) en un mes:</p>
      <div class="example-calc">
        <div class="calc-item highlight">
          <span class="calc-label">Mes 1 (25% × 10 clientes):</span>
          <span class="calc-value">$7,500</span>
        </div>
        <div class="calc-item">
          <span class="calc-label">Mes 2 (10% × 10 clientes):</span>
          <span class="calc-value">$3,000</span>
        </div>
        <div class="calc-item">
          <span class="calc-label">Mes 3 (10% × 10 clientes):</span>
          <span class="calc-value">$3,000</span>
        </div>
        <div class="calc-item">
          <span class="calc-label">Mes 4 (10% × 10 clientes):</span>
          <span class="calc-value">$3,000</span>
        </div>
        <div class="calc-item">
          <span class="calc-label">Mes 5 (10% × 10 clientes):</span>
          <span class="calc-value">$3,000</span>
        </div>
        <div class="calc-item">
          <span class="calc-label">Mes 6 (10% × 10 clientes):</span>
          <span class="calc-value">$3,000</span>
        </div>
        <div class="calc-total">
          <span class="total-label">Total en 6 meses:</span>
          <span class="total-value">$22,500</span>
        </div>
      </div>
      <p class="example-note">Y a partir del mes 7 sigues ganando $3,000/mes de forma recurrente mientras tus 10 clientes permanezcan activos. En 1 año ganarías <strong>$40,500 MXN</strong> con una sola campaña de ventas.</p>
    </div>
  </div>
</section>

<!-- Cómo Funciona -->
<section class="process-section">
  <div class="container">
    <div class="section-header">
      <h2>¿Cómo <strong>funciona</strong>?</h2>
      <p>4 pasos simples para empezar a ganar</p>
    </div>

    <div class="process-grid">
      <div class="process-step">
        <div class="step-badge">1</div>
        <div class="step-icon-wrapper">
          <img src="icons/user-solid-full.svg" alt="" class="step-icon" width="32" height="32">
        </div>
        <h3>Regístrate</h3>
        <p>Llena el formulario en esta página. Te contactamos en menos de 24 horas para validar tu perfil.</p>
      </div>

      <div class="process-step">
        <div class="step-badge">2</div>
        <div class="step-icon-wrapper">
          <img src="icons/book-open-solid-full.svg" alt="" class="step-icon" width="32" height="32">
        </div>
        <h3>Capacítate</h3>
        <p>Recibes entrenamiento sobre el producto, materiales de venta y acceso a una cuenta demo para mostrar a clientes.</p>
      </div>

      <div class="process-step">
        <div class="step-badge">3</div>
        <div class="step-icon-wrapper">
          <img src="icons/handshake-solid-full.svg" alt="" class="step-icon" width="32" height="32">
        </div>
        <h3>Vende</h3>
        <p>Contacta a tus prospectos, muestra el producto y cierra ventas. Te asignamos un código único para trackear tus clientes.</p>
      </div>

      <div class="process-step accent">
        <div class="step-badge">4</div>
        <div class="step-icon-wrapper">
          <img src="icons/floppy-disk-solid-full.svg" alt="" class="step-icon" width="32" height="32">
        </div>
        <h3>Cobra</h3>
        <p>Cada 15 del mes recibes tu transferencia con el reporte detallado de todas tus comisiones. Simple y transparente.</p>
      </div>
    </div>
  </div>
</section>

<!-- Políticas y Condiciones -->
<section class="policies-section">
  <div class="container">
    <div class="section-header">
      <h2>Políticas y <strong>Condiciones</strong></h2>
      <p>Todo lo que necesitas saber</p>
    </div>

    <div class="policies-content">
      <ul class="policies-list">
        <li>
          <img src="icons/check-solid.svg" alt="" class="check-icon" width="18" height="18">
          <div class="policy-text">
            <strong>Venta válida:</strong> La comisión se activa cuando el cliente paga su primera mensualidad completa.
          </div>
        </li>
        <li>
          <img src="icons/check-solid.svg" alt="" class="check-icon" width="18" height="18">
          <div class="policy-text">
            <strong>Comisión del 25%:</strong> Se paga al mes siguiente del primer pago del cliente (aproximadamente 30-45 días después de la venta).
          </div>
        </li>
        <li>
          <img src="icons/check-solid.svg" alt="" class="check-icon" width="18" height="18">
          <div class="policy-text">
            <strong>Comisión del 10%:</strong> Se paga mensualmente mientras el cliente permanezca activo y al corriente en sus pagos.
          </div>
        </li>
        <li>
          <img src="icons/check-solid.svg" alt="" class="check-icon" width="18" height="18">
          <div class="policy-text">
            <strong>Método de pago:</strong> Transferencia bancaria cada día 15 del mes.
          </div>
        </li>
        <li>
          <img src="icons/check-solid.svg" alt="" class="check-icon" width="18" height="18">
          <div class="policy-text">
            <strong>Mínimo de pago:</strong> No hay mínimo. Si ganaste $100, recibes $100.
          </div>
        </li>
        <li>
          <img src="icons/check-solid.svg" alt="" class="check-icon" width="18" height="18">
          <div class="policy-text">
            <strong>Cancelación del cliente:</strong> Si el cliente cancela, simplemente dejas de recibir la comisión recurrente. No hay penalización ni devolución.
          </div>
        </li>
        <li>
          <img src="icons/check-solid.svg" alt="" class="check-icon" width="18" height="18">
          <div class="policy-text">
            <strong>Reporte de comisiones:</strong> Recibes un reporte detallado mensual con todas tus ventas activas, comisiones generadas y pagos.
          </div>
        </li>
        <li>
          <img src="icons/check-solid.svg" alt="" class="check-icon" width="18" height="18">
          <div class="policy-text">
            <strong>Soporte continuo:</strong> Acceso a nuestro equipo de ventas para dudas, demos conjuntas y estrategias de cierre.
          </div>
        </li>
      </ul>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="faq-section">
  <div class="container">
    <div class="section-header">
      <h2>Preguntas <strong>Frecuentes</strong></h2>
    </div>

    <div class="faq-grid">
      <div class="faq-item" *ngFor="let faq of faqs">
        <h3 class="faq-question">
          <img src="icons/triangle-exclamation-solid.svg" alt="" class="faq-icon" width="20" height="20">
          {{ faq.question }}
        </h3>
        <p class="faq-answer">{{ faq.answer }}</p>
      </div>
    </div>
  </div>
</section>

<!-- Formulario de Registro -->
<section id="partner-form" class="form-section">
  <div class="container">
    <div class="form-layout">
      <div class="form-info">
        <h2>¿Listo para <strong>empezar a ganar</strong>?</h2>
        <p>Completa el formulario y nos pondremos en contacto contigo en menos de 24 horas para iniciar tu proceso de registro.</p>

        <div class="form-benefits">
          <div class="benefit-item">
            <img src="icons/phone-solid.svg" alt="" class="benefit-icon" width="18" height="18">
            <span>Llamada de bienvenida en 24h</span>
          </div>
          <div class="benefit-item">
            <img src="icons/book-open-solid-full.svg" alt="" class="benefit-icon" width="18" height="18">
            <span>Capacitación completa incluida</span>
          </div>
          <div class="benefit-item">
            <img src="icons/laptop-solid-full.svg" alt="" class="benefit-icon" width="18" height="18">
            <span>Materiales de venta profesionales</span>
          </div>
          <div class="benefit-item">
            <img src="icons/people-group-solid-full.svg" alt="" class="benefit-icon" width="18" height="18">
            <span>Soporte del equipo de ventas</span>
          </div>
        </div>

        <div class="trust-indicators">
          <div class="trust-item">
            <img src="icons/lock-solid-full.svg" alt="" class="trust-icon" width="16" height="16">
            <span>Información 100% confidencial</span>
          </div>
          <div class="trust-item">
            <img src="icons/fire-solid-full.svg" alt="" class="trust-icon" width="16" height="16">
            <span>Respuesta en 24 horas</span>
          </div>
          <div class="trust-item">
            <img src="icons/map-pin-solid-full.svg" alt="" class="trust-icon" width="16" height="16">
            <span>Empresa mexicana en Los Mochis</span>
          </div>
        </div>
      </div>

      <div class="form-container">
        <form [formGroup]="partnerForm" (ngSubmit)="onSubmit()" class="partner-form">
          <div class="form-grid">
            <!-- Nombre completo -->
            <div class="form-group full-width">
              <label for="name">Nombre completo *</label>
              <input
                type="text"
                id="name"
                formControlName="name"
                [class.error]="isFieldInvalid('name')"
                placeholder="Tu nombre completo">
              <span class="error-message" *ngIf="isFieldInvalid('name')">
                {{ getFieldError('name') }}
              </span>
            </div>

            <!-- Email -->
            <div class="form-group">
              <label for="email">Email *</label>
              <input
                type="email"
                id="email"
                formControlName="email"
                [class.error]="isFieldInvalid('email')"
                placeholder="tu-email@ejemplo.com">
              <span class="error-message" *ngIf="isFieldInvalid('email')">
                {{ getFieldError('email') }}
              </span>
            </div>

            <!-- Teléfono/WhatsApp -->
            <div class="form-group">
              <label for="phone">Teléfono/WhatsApp *</label>
              <input
                type="tel"
                id="phone"
                formControlName="phone"
                [class.error]="isFieldInvalid('phone')"
                placeholder="668-123-4567">
              <span class="error-message" *ngIf="isFieldInvalid('phone')">
                {{ getFieldError('phone') }}
              </span>
            </div>

            <!-- Experiencia -->
            <div class="form-group full-width">
              <label for="experience">¿Tienes experiencia vendiendo software? *</label>
              <select
                id="experience"
                formControlName="experience"
                [class.error]="isFieldInvalid('experience')">
                <option value="" disabled selected>Selecciona una opción</option>
                <option value="Si">Sí, tengo experiencia</option>
                <option value="No">No, pero tengo ganas de aprender</option>
                <option value="Algo">Algo, he vendido productos similares</option>
              </select>
              <span class="error-message" *ngIf="isFieldInvalid('experience')">
                {{ getFieldError('experience') }}
              </span>
            </div>

            <!-- Estrategia -->
            <div class="form-group full-width">
              <label for="strategy">¿Cómo planeas conseguir clientes? *</label>
              <textarea
                id="strategy"
                formControlName="strategy"
                [class.error]="isFieldInvalid('strategy')"
                rows="4"
                placeholder="Cuéntanos tu estrategia: contactos que tienes, industrias a las que puedes llegar, redes sociales, networking, etc."></textarea>
              <span class="error-message" *ngIf="isFieldInvalid('strategy')">
                {{ getFieldError('strategy') }}
              </span>
            </div>

            <!-- Términos -->
            <div class="form-group full-width checkbox-group">
              <label class="checkbox-label">
                <input
                  type="checkbox"
                  id="terms"
                  formControlName="terms"
                  [class.error]="isFieldInvalid('terms')">
                <span>Acepto los términos y condiciones del programa de comisionistas</span>
              </label>
              <span class="error-message" *ngIf="isFieldInvalid('terms')">
                Debes aceptar los términos y condiciones
              </span>
            </div>
          </div>

          <div class="form-actions">
            <button
              type="submit"
              class="btn-submit"
              [disabled]="isSubmitting"
              [class.loading]="isSubmitting">
              <span *ngIf="!isSubmitting">Enviar Solicitud</span>
              <span *ngIf="isSubmitting">
                <img src="icons/spinner-solid.svg" alt="" class="spinner-icon" width="16" height="16">
                Enviando...
              </span>
            </button>
          </div>

          <div *ngIf="submitMessage" class="submit-message" [class.success]="submitSuccess" [class.error]="!submitSuccess">
            <img *ngIf="submitSuccess" src="icons/check-solid.svg" alt="" class="status-icon" width="16" height="16">
            <img *ngIf="!submitSuccess" src="icons/triangle-exclamation-solid.svg" alt="" class="status-icon" width="16" height="16">
            {{ submitMessage }}
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<!-- CTA Final -->
<section class="final-cta-section">
  <div class="container">
    <div class="cta-content">
      <h2>Empieza a Construir tu <strong>Ingreso Recurrente</strong></h2>
      <p>Únete a nuestro equipo de comisionistas y transforma tu red de contactos en ingresos mensuales predecibles.</p>

      <div class="cta-actions">
        <button (click)="scrollToForm()" class="btn-primary-cta">
          <img src="icons/handshake-solid-full.svg" alt="" class="cta-icon" width="18" height="18">
          Registrarme Ahora
        </button>
        <button (click)="openWhatsApp()" class="btn-secondary-cta">
          <img src="icons/whatsapp.svg" alt="" class="cta-icon" width="18" height="18">
          Contactar por WhatsApp
        </button>
      </div>

      <div class="final-guarantees">
        <div class="guarantee-item">
          <img src="icons/check-solid.svg" alt="" class="guarantee-icon" width="16" height="16">
          <span>Sin inversión inicial</span>
        </div>
        <div class="guarantee-item">
          <img src="icons/chart-simple-solid-full.svg" alt="" class="guarantee-icon" width="16" height="16">
          <span>Comisiones recurrentes</span>
        </div>
        <div class="guarantee-item">
          <img src="icons/lock-solid-full.svg" alt="" class="guarantee-icon" width="16" height="16">
          <span>Pagos puntuales día 15</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<app-footer></app-footer>
